/** Product name — the platform is offered by Légal.invest. */
export const APP_NAME = "li-wallet";

/**
 * Légal.invest logo; the light/dark variant is picked in CSS from the active
 * theme (`.logo-light` / `.logo-dark`, see index.css).
 */
export function BrandLogo({ className = "" }: { className?: string }) {
  return (
    <span className={`brand-logo ${className}`}>
      <img className="logo-light" src="/logo-light.jpg" alt="Légal.invest" />
      <img className="logo-dark" src="/logo-dark.jpg" alt="Légal.invest" />
    </span>
  );
}

/** Logo + product name, used in the sidebar, the mobile top bar and auth screens. */
export function Brand({ suffix, className = "" }: { suffix?: string; className?: string }) {
  return (
    <div className={`brand ${className}`}>
      <BrandLogo />
      <span className="brand-name">
        {APP_NAME}
        {suffix && <span className="brand-suffix">{suffix}</span>}
      </span>
    </div>
  );
}
